import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { DebugClearStorageButton } from './DebugClearStorageButton';

interface AuthGateScreenProps {
  readonly gameThemeStyle?: CSSProperties;
  readonly error: string | null;
}

export function AuthGateScreen({ gameThemeStyle, error }: AuthGateScreenProps) {
  const { t } = useTranslation();

  return (
    <main
      className="min-h-dvh w-full flex items-center justify-center px-6 select-none"
      style={gameThemeStyle}
    >
      <div className="relative flex w-full max-w-[360px] flex-col items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.07] px-8 py-7 text-center shadow-[0_20px_60px_rgba(0,0,0,0.38)] backdrop-blur-md">
        <p className="text-lg font-semibold text-white">
          {t('auth.failedTitle', { defaultValue: 'Failed to authenticate' })}
        </p>
        <p className="max-w-[280px] text-sm leading-relaxed text-zinc-400">{error}</p>
        <DebugClearStorageButton className="!static !top-0 max-w-[150px] !w-full" />
      </div>
    </main>
  );
}
